import {pxToRem} from '../../utills/pxToRem'
import {fonts} from '../../theme/foundations/fonts'

export const continueButton = {
    height: pxToRem(40),
    paddingTop: [pxToRem(12)],
    paddingBottom: [pxToRem(12)],
    paddingLeft: [pxToRem(20)],
    paddingRight: [pxToRem(20)],
    color: 'white',
    backgroundColor: 'cav_red',
    fontFamily: fonts.primary,
    fontSize: [pxToRem(14)],
    fontWeight: 700,
    lineHeight: pxToRem(13.5),
    letterSpacing: pxToRem(1.5),
    textTransform: 'uppercase',
    borderRadius: 0,
    margin: `0 !important`,
    '&:hover': {
        color: 'cav_red',
        backgroundColor: 'white'
    },
    '&:disabled': {
        backgroundColor: 'cav_red',
        '&:hover': {
            color: 'white',
            backgroundColor: 'cav_red'
        }
    }
}
